import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  transition: border-color 0.2s ease-out, background-color 0.2s ease-out;\n  :focus-within {\n    outline: none;\n    border-color: ", ";\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_AUTOFILLED, BACKGROUND_GRAY, ELEMENT_GRAY, RIOJA_RED, SENSATION_WHITE } from '../../colors';
var FormWrapper = styled.div(_templateObject(), ELEMENT_GRAY, SENSATION_WHITE, ADVENTURE_GREEN, function (_ref) {
  var $autofilled = _ref.$autofilled;
  return $autofilled ? "\n        background-color: " + ADVENTURE_GREEN_AUTOFILLED + ";\n      " : '';
}, function (_ref2) {
  var $focused = _ref2.$focused;
  return $focused ? "\n        border-color: " + ADVENTURE_GREEN + ";\n      " : '';
}, function (_ref3) {
  var $error = _ref3.$error,
      $disabled = _ref3.$disabled,
      $withPersistError = _ref3.$withPersistError;
  return $error ? "\n        border-color: " + RIOJA_RED + ($withPersistError && !$disabled ? ' !important' : '') + ";\n      " : '';
}, function (_ref4) {
  var $disabled = _ref4.$disabled;
  return $disabled ? "\n        border-color: " + ELEMENT_GRAY + ";\n        background-color: " + BACKGROUND_GRAY + ";\n      " : '';
}, function (_ref5) {
  var $withPrefix = _ref5.$withPrefix;
  return $withPrefix ? "\n        border-left: 0;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      " : '';
}, function (_ref6) {
  var $withSuffix = _ref6.$withSuffix;
  return $withSuffix ? "\n        border-right: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      " : '';
}, function (_ref7) {
  var $noBorder = _ref7.$noBorder;
  return $noBorder ? "\n        border: none !important;\n      " : '';
});
export default FormWrapper;